var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-vh-100 p-3"},[_vm._v(" Nam želite kaj sporočiti? "),_c('br'),_vm._v(" Report a bug "),_c('br'),_vm._v(" Suggest improvement"),_c('br'),_vm._v(" Praise"),_c('br'),_vm._v(" Other "),_c('br')])
}]

export { render, staticRenderFns }